<!--
2022-08-04 Matt bonus调整 https://trello.com/c/4GwUwvYl
-->
<template>
  <div class="claimBonusPage">
    <TopBack :title="$t('lang.wagering.title')"/>
    <div class="tabContainer">
      <div class="tabItem" :class="{act: type==='bonus'}" @click="type = 'bonus'">{{type==='bonus'?'Bonus':'Bonus'}}</div>
      <div class="tabItem" :class="{act: type==='history'}" @click="type = 'history'">{{type==='history'?'History':'History'}}</div>
      <div class="tabItem" :class="{act: type==='rules'}" @click="type = 'rules'">{{type==='rules'?'Rules':'Rules'}}</div>
    </div>
    <div class="bonusContainer">
      <div class="tab" v-if="type==='bonus'">
        <div class="bonus-operation-row">
          <div class="caption">
            <!--<span>{{$t('lang.account.bonus')}}</span>-->
            <span>{{$t('lang.account.bonusBalance')}}</span>
          </div>
          <div class="inputRow">
            <!--<div>{{fetchCurrency[userInfo.CurrencyName]}}{{separateThousand(this.accountInfo.Bonus)}}</div>-->
            <div class="bonus-balance">{{getCurrency()}}{{separateThousand(this.accountInfo.Bonus)}}</div>
            <div class="claim" @click="goToActivityPage">{{$t('lang.account.moreBonus')}}</div>
          </div>
          <div class="splitter"></div>
        </div>
        <Loadmore
          :bottomPullText="$t('lang.loadingStatus.pullToLoad')"
          :bottomDropText="$t('lang.loadingStatus.releaseToLoad')"
          :bottomLoadingText="$t('lang.loadingStatus.loading')"
          :auto-fill="false"
          :bottom-method="getListData"
          :bottom-all-loaded="hasLoadListAll"
          ref="loadmoreList">
          <div class="row" v-for="(item, index) in claimBonusList" :key="index">
            <div class="bonus-bar" v-if="item.hasTopBar"/>
            <div class="bonus-row">
              <div class="bonus-time">
                <div class="left">
                  <span>{{item.CreatedTime}}</span>
                </div>
                <div class="right">
                  <span>{{$t('lang.bonus.expire')}} {{item.ExpireTime}}</span>
                </div>
              </div>
              <div class="bonus-num">
                <div class="left"><span>{{$t('lang.bonus.received')}}</span></div>
                <div class="right"><span>+{{currencyIcon}}{{separateThousand(item.OriginalAmount)}}</span></div>
              </div>
            </div>
            <div class="bonus-progress">
              <div class="left"><span>{{$t('lang.bonus.completed')}}</span></div>
              <div class="progress">
                <div class="progress-done" :style="{width: item.completPercent+'%'}"></div>
              </div>
              <div class="right"><span>+{{currencyIcon}}{{separateThousand(item.ReadyForClaimAmount)}}</span></div>
            </div>
            <!--<div :class="{'submit': item.completPercent === 100, 'submit-disable': item.completPercent != 100}"
                @click="claimBonus(item.Id)" v-if="item.completPercent === 100">Claim</div>
            <div :class="{'submit': item.completPercent === 100, 'submit-disable': item.completPercent != 100}"
                @click="cannotClaimBonusPrompt(separateThousand(item.OriginalAmount - item.ReadyForClaimAmount))" v-if="item.completPercent != 100">Claim</div>-->
          </div>
          <div class="showMore" v-if="!hasLoadListAll"><img :src="showMore" alt=""></div>
        </Loadmore>
        <div class="row" v-if="claimBonusList.length === 0">
          <div class="no-data">
            <span style="margin-right: 10px">-</span><span>{{$t('lang.bonus.noDataAvailable')}}</span><span style="margin-left: 10px">-</span>
          </div>
        </div>
      </div>
      <div class="tab" v-if="type === 'history'">
        <Loadmore
          :bottomPullText="$t('lang.loadingStatus.pullToLoad')"
          :bottomDropText="$t('lang.loadingStatus.releaseToLoad')"
          :bottomLoadingText="$t('lang.loadingStatus.loading')"
          :auto-fill="false"
          :bottom-method="getHistoryData"
          :bottom-all-loaded="hasLoadHistoryAll"
          ref="loadmoreHistory">
          <div class="row" v-for="(item, index) in claimBonusHistoryList" :key="index">
            <div class="history-row">
              <div class="history-time">
                <div class="left">
                  <span>{{item.CreatedTime}}</span>
                </div>
                <div class="right" v-if="!item.IsClaimed">
                  <span>{{$t('lang.bonus.expire')}} {{item.ExpireTime}}</span>
                </div>
              </div>
              <div class="history-num">
                <div class="left"><span v-if="item.IsClaimed">{{$t('lang.bonus.claimed')}}</span><span v-else>{{$t('lang.bonus.unclaimed')}}</span></div>
                <div class="right"><span>{{currencyIcon}}{{separateThousand(item.OriginalAmount)}}</span></div>
              </div>
            </div>
          </div>
          <div class="showMore" v-if="!hasLoadHistoryAll"><img :src="showMore" alt=""></div>
        </Loadmore>
        <div class="row" v-if="claimBonusHistoryList.length === 0">
          <div class="no-data">
            <span style="margin-right: 10px">-</span><span>{{$t('lang.bonus.noDataAvailable')}}</span><span style="margin-left: 10px">-</span>
          </div>
        </div>
      </div>
      <div class="tab eran-rule" v-if="type === 'rules'" v-html="bonusRulesHtml">
      </div>
    </div>
  </div>
</template>

<script>
import {Toast, Loadmore} from 'mint-ui'
import request from '@/service'
import {mapMutations} from 'vuex'
import {separateThousand} from '@/utils'
import {fetchCurrency} from '@/constant'
import showMore from '@/assets/images/common/showMore.gif'
import TopBack from '@/components/TopBack/index'
import axios from 'axios'

export default {
  name: 'ClaimBonus',
  props: ['handelBack'],
  data () {
    return {
      title: 'My Wallet',
      type: 'bonus',
      currencyIcon: localStorage.getItem('currencyIcon'),
      claimBonusList: [],
      claimBonusHistoryList: [],
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      separateThousand,
      fetchCurrency,
      skipListNum: 0,
      takeListNum: 10,
      firstLoadList: true,
      hasLoadListAll: true,
      skipHistoryNum: 0,
      takeHistoryNum: 10,
      firstLoadHistory: true,
      hasLoadHistoryAll: true,
      showMore,
      gamesWagering: [],
      accountInfo: {},
      bonusRulesHtml: ''
    }
  },
  mounted () {
    this.loadData()
    this.fetchAccount()
    this.getListData()
    this.getHistoryData()
    // this.getGamesWagering() // HHY 注释于20220629
  },
  components: {
    Loadmore,
    TopBack
  },
  methods: {
    ...mapMutations({
      setUserVerifyInfo: 'setUserVerifyInfo'
    }),
    getListData () {
      if (this.userInfo) {
        const data = {
          UserId: this.userInfo.UserId,
          Skip: this.skipListNum,
          Take: this.takeListNum
        }
        request('post', '/innovation/account/claim/bonus/list', data)
          .then(res => {
            this.claimBonusList = this.claimBonusList.concat(res.Data)
            this.skipListNum += this.takeListNum
            this.hasLoadListAll = this.skipListNum >= res.Total

            if (!this.firstLoadList) {
              this.$refs.loadmoreList.onBottomLoaded()
            }
            this.firstLoadList = false
          })
      }
    },
    getHistoryData () {
      if (this.userInfo) {
        const data = {
          UserId: this.userInfo.UserId,
          Skip: this.skipHistoryNum,
          Take: this.takeHistoryNum
        }
        request('post', '/innovation/account/claim/bonus/history', data)
          .then(res => {
            console.log({res})
            this.claimBonusHistoryList = this.claimBonusHistoryList.concat(res.Data)
            this.skipHistoryNum += this.takeHistoryNum
            this.hasLoadHistoryAll = this.skipHistoryNum >= res.Total
            console.log(this.hasLoadHistoryAll + ':' + this.skipHistoryNum + ':' + res.Total)

            if (!this.firstLoadHistory) {
              this.$refs.loadmoreHistory.onBottomLoaded()
            }
            this.firstLoadHistory = false
          })
      }
    },
    getGamesWagering: function () {
      const url = '/innovation/game/getgamewagering'
      const data = {
      }
      request('post', url, data).then(res => {
        this.gamesWagering = res.GamesWageringList
      })
    },
    /****
     * 完整领取某条Bonus
     * */
    claimBonus (id) {
      request(
        'post',
        '/innovation/account/claim/bonus',
        {
          UserId: this.userInfo.UserId,
          id: id
        }).then(res => {
        console.log(res)
        if (res.Code === 1) {
          Toast(this.$t('lang.common.success'))

          this.resetData()
        } else {
          Toast(this.$t('lang.common.fail'))
        }
      })
    },
    resetData () {
      this.claimBonusList = []
      this.claimBonusHistoryList = []
      this.skipListNum = 0
      this.takeListNum = 10
      this.skipHistoryNum = 0
      this.takeHistoryNum = 10
      this.firstLoadList = true
      this.hasLoadListAll = true
      this.firstLoadHistory = true
      this.hasLoadHistoryAll = true

      this.getListData()
      this.getHistoryData()
    },
    cannotClaimBonusPrompt (leftAmount) {
      Toast('You still have ₹' + leftAmount + ' left to complete this bonus. Please make bets to complete the bonus. For Bonus Rules, please check "Rules" tab. ')
    },
    fetchAccount () {
      if (this.userInfo) {
        const url = '/innovation/account/getuseraccount'
        const data = {
          userId: this.userInfo.UserId
        }
        request('post', url, data).then(res => {
          console.log(res)
          this.accountInfo = res
        }).catch(err => {
          console.log(err)
        })
      }
    },
    goToActivityPage () {
      this.$router.push('/Promotion')
    },
    /****
     * 2022-01-01 CHP 领取Bonus（支持部分领取）
     * */
    toClaimBonus () {
      if (!this.accountInfo.ReadyToConvertBonus ||
        this.accountInfo.ReadyToConvertBonus === 0) {
        Toast(this.$t('lang.account.noBonusReadyForClaim'))
        return
      }

      const url = '/innovation/account/convertuserbonus'
      const data = {
        userId: this.userInfo.UserId,
        bonusToConvert: this.accountInfo.ReadyToConvertBonus
      }
      request('post', url, data).then(res => {
        console.log(res)
        if (res.Code === 1) {
          this.accountInfo = {
            ...this.accountInfo,
            ...res
          }
          // Toast(this.$t('lang.common.success'))
          Toast(this.$t('lang.account.convertBonusSuccess_1') +
            ' ' + this.fetchCurrency[this.userInfo.CurrencyName] + res.ConvertedBonus + ' ' +
            this.$t('lang.account.convertBonusSuccess_2'))
        } else {
          Toast(this.$t('lang.common.fail'))
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getCurrency () { // 2022-08-03 HYY 修改，防止用户未登录就访问CurrencyName
      if (this.userInfo) {
        return this.fetchCurrency[this.userInfo.CurrencyName]
      } else {
        // this.$store.commit('setLoginPopShow', true)
        this.$router.push('/Login')
      }
    },
    loadData: function () { // 2022-08-05 Matt，加载Bonus Rule静态文件
      const that = this
      let internation = ''
      if (localStorage.getItem('locale') === 'IN') {
        internation = 'IN'
      } else {
        internation = 'INT'
      }
      const url = location.origin + '/static/startupPopup-' + internation + '.json'
      axios.get(url).then(res => {
        if (res.data != null) {
          this.startupPopupConfig = res.data
          const bonusRules = this.startupPopupConfig.BonusRules
          const htmlFileURL = location.origin + '/static/bonusRules/' + bonusRules.fileNamePrefix + '-' + this.$store.state.internation + '.html'
          axios.get(htmlFileURL).then(res => {
            if (res.data != null) {
              that.bonusRulesHtml = res.data
            }
          })
        }
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (to.query.param) {
        vm.type = to.query.param
      }
    })
  }
}
</script>

<style lang="less" scoped>
  .claimBonusPage {
    margin-top: 66px;
    left: -16px;
    width: 100vw;
    height: calc(100vh - 78px);
    background-color: #151515;
    .tabContainer {
      padding: 14px 15px 0 15px;
      display: flex;
      margin-bottom: 20px;
      .tabItem {
        flex: 1;
        font-size: 18px;
        line-height: 32px;
        color: rgba(246, 217, 170, 0.5);
        text-align: center;
        margin: 0 20px;
      }
      .act {
        color: #F6D9AA;
        border-bottom: 2px solid #F6D9AA;
      }
    }
    .bonusContainer {
      height: calc(100vh - 205px);

      .bonus-operation-row {
        margin-bottom: 30px;
        &:last-child {
          margin-bottom: 0;
        }
        .inputRow, .btnRow {
          div {
            line-height: 40px;
            border: 1px solid rgba(246, 217, 170, 0.5);
            border-radius: 6px;
          }
          div.bonus-balance {
            text-align: center;
            border: none;
          }
        }
        .inputRow {
          display: flex;
          &:not(:last-child) {
            /*margin-bottom: 16px;*/
            margin-bottom: 8px;
          }
          div {
            flex: 1;
            font-size: 16px;
            color: #fff;
            text-align: right;
            padding-right: 15px;
            &:not(:first-child) {
              margin-left: 9px;
            }
            input {
              font-size: 16px;
              color: #fff;
              text-align: right;
            }
          }
          .selected {
            font-size: 20px;
            font-weight: 600;
            color: #000;
            background-color: #F6D9AA;
          }
          .claim {
            text-align: center;
            color:#000000;
            background-color: #F6D9AA;
            font-size: 18px;
            padding: 0;
          }
        }
        .caption {
          font-size: 14px;
          line-height: 21px;
          color: #F6D9AA;
          margin-bottom: 10px;
          display: flex;
          justify-content: space-between;
        }
      }

      .splitter {
        border-bottom: #F6D9AA 1px solid;
        margin: 15px 0px;
      }

      .tab{
        padding: 0 15px 70px 15px;
        height: calc(100vh - 205px);
        overflow: auto;
        .row {
          margin-bottom: 20px;
          .bonus-bar {
            margin-bottom: 20px;
            height: 0px;
            left: 15px;
            top: 359px;
            border: 1px solid #686868;
          }
          .bonus-row {
            height: 59px;
            background: #2F2F2F;
            text-align: left;
            border-radius: 6px;
            .bonus-time {
              height: 14px;
              font-family: Roboto;
              font-style: normal;
              font-weight: normal;
              font-size: 12px;
              line-height: 14px;
              /*width: 150px;*/
              color: #686868;
              /*padding-top: 8px;
              padding-left: 15px;*/
              padding: 8px 15px;
              display: flex;
              white-space: nowrap;
              .left {
                text-align: left;
                flex: 1;
              }

              .right {
                text-align: right;
                flex: 1;
              }
            }
            .bonus-num {
              height: 23px;
              padding-top: 9px;
              padding-left: 15px;
              font-family: Roboto;
              font-style: normal;
              font-weight: normal;
              font-size: 20px;
              line-height: 23px;
              text-transform: capitalize;
              display: flex;
              justify-content: flex-end;
              margin-top: 5px;
              color: #F6D9AA;
              .left{
                display: inline-flex;
                margin-right: auto;
                flex: 1;
              }
              .right{
                display: inline-flex;
                justify-content: flex-end;
                margin-right: 12px;
                flex: 1;
              }
            }
          }
          .history-row {
            height: 59px;
            background: #2F2F2F;
            text-align: left;
            border-radius: 6px;
            .history-time {
              height: 14px;
              font-family: Roboto;
              font-style: normal;
              font-weight: normal;
              font-size: 12px;
              line-height: 14px;
              color: #686868;
              padding: 8px 15px;
              display: flex;
              white-space: nowrap;
              .left {
                text-align: left;
                flex: 1;
              }

              .right {
                text-align: right;
                flex: 1;
              }
            }
            .history-num {
              height: 23px;
              padding-top: 9px;
              padding-left: 15px;
              margin-top: 5px;
              font-family: Roboto;
              font-style: normal;
              font-weight: normal;
              font-size: 20px;
              line-height: 23px;
              text-transform: capitalize;
              display: flex;
              justify-content: flex-end;
              color: #F6D9AA;
              .left{
                display: inline-flex;
                margin-right: auto;
                color: #686868;
              }
              .right{
                display: inline-flex;
                justify-content: flex-end;
                margin-right: 12px;
              }
            }
          }
          .bonus-progress {
            display: inline-flex;
            padding-top: 10px;
            font-size: 12px;
            /*width: 345px;*/

            .left{
              padding-left: 15px;
              display: inline-flex;
              display: inline-flex;
              margin-right: auto;
              width: 80px;
            }
            .progress{
              display: inline-flex;
              display: inline-flex;
              border-radius: 5px;
              position: relative;
              margin: 3px 10px;
              height: 7px;
              width: calc(100vw - 70px - 20px - 80px - 30px);
              border: 1px solid #686868;
              box-sizing: border-box;
              border-radius: 12px;
              .progress-done {
                background: #FFC700;
                border-radius: 12px;
                width: 0;
                transition: width 1s ease 0.3s;
              }
            }
            .right{
              display: inline-flex;
              display: inline-flex;
              justify-content: flex-end;
              color: #EDB905;
              margin-right: 12px;
              width: 70px;
              white-space: nowrap;
              overflow: hidden;
            }
          }
          .no-data {
            text-align: center;
            font-size: 16px;
            margin: 20px 0 0 0;
          }
        }
      }
      .eran-rule{
          .title {
            font-size: 14px;
            margin: 15px 0px;
            color: #f6d9aa;
          }
          .content {
            font-size: 14px;
            line-height: 24px;
            color: #EFEFEF;
          }
          .rule-item{
            display: flex;
            margin-bottom: 10px;
            .rule-number{
                width: 40px;
                height: 40px;
                border-radius: 50%;
                border: 1px solid #F6D9AA;
                text-align: center;
                line-height: 40px;
                font-size: 20px;
                color: #F6D9AA;
            }
            .rule-content{
              width: calc(100vw - 32px - 40px);
              padding: 0 0px 0 10px;
              .rule-title{
                color: #F6D9AA;
                font-size: 16px;
                line-height: 20px;
                margin: 0 0 5px 0;
              }
              .rule-description{
                color: #DADADA;
                font-size: 14px;
                line-height: 20px;
              }
            }
          }
          .list-wrapper {
          .item-header {
            font-size: 14px;
            font-weight: bold;
            color: #f6d9aa;
          }

          .list-item {
            display: flex;
            font-size: 12px;
            line-height: 20px;
            border-bottom: #686868 solid 1px;

            .name {
              white-space: nowrap;
              overflow: hidden;
              flex: 2;
              margin-right: 5px;
            }

            .provider {
              white-space: nowrap;
              overflow: hidden;
              flex: 2;
            }

            .wagering {
              white-space: nowrap;
              flex: 1;
              text-align: center;
            }
          }
        }
      }
      .submit {
        margin-top: 10px;
        font-size: 20px;
        line-height: 42px;
        color: #000D2E;
        text-align: center;
        background-color: #F6D9AA;
        border-radius: 6px;
      }
      .submit-disable {
        margin-top: 10px;
        font-size: 20px;
        text-align: center;
        color: #262626;
        line-height: 42px;
        border: 1px solid #262626;
        box-sizing: border-box;
        border-radius: 6px;
      }
    }
    .ani_dot {
      font-family: simsun;
    }
    .showMore {
      text-align: center;
      img {
        width: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Account/bonus.vue